/**
 * @param  {...boolean} predicates
 * @returns {boolean}
 */
export function and(...predicates) {
  return predicates.every((it) => !!it)
}

/**
 * @param  {...boolean} predicates
 * @returns {boolean}
 */
export function or(...predicates) {
  return predicates.some((it) => !!it)
}

/**
 * @param {string[]} texts
 * @returns {string}
 */
export function simpleSection(texts) {
  return texts.join('\n')
}

/**
 * @param {string} title
 * @param {string[]} bullets
 * @returns {string}
 */
export function bulletSection(title, bullets) {
  return [title, bullets.map((bullet) => `  - ${bullet}`).join('\n')].join('\n')
}
